export const WorldDataTagIDs = {
    header: "#dve_header",
    dataType: "#dve_data_type",
    dimensionId: "#dve_dimension_id",
    positionX: "#dve_p_x",
    positionY: "#dve_p_y",
    positionZ: "#dve_p_z",
};
